import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ChangelogMixin from "@Broker/@Modules/clients/board/client-profile/mixins/changelog-mixin.js";
import ProfileAvatar from "@Shared/components/general/profile-avatar";
import ClientProfileNameLabel from "@Broker/@Modules/clients/board/client-profile/components/shared/client-profile-name-label.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "BoardChangelogItem",
  components: {
    ClientProfileNameLabel,
    ProfileAvatar
  },
  mixins: [ChangelogMixin],
  props: {
    changelog: {
      type: Object,
      default: () => ({})
    },
    userDetails: {
      type: Object,
      default: () => ({})
    },
    boardId: {
      type: [String, Number],
      default: ""
    },
    origin: {
      type: String,
      validator: prop => {
        var _context;
        return _includesInstanceProperty(_context = ["boards", "client-profile"]).call(_context, prop);
      },
      default: "boards"
    }
  },
  computed: {
    value() {
      return this.changelog.value;
    },
    clientProfileName() {
      const {
        givenName = "",
        familyName = ""
      } = this.changelog.clientProfileDetails;
      return `${givenName} ${familyName}`;
    },
    clientProfileDetails() {
      return this.changelog.clientProfileDetails || {};
    },
    clientProfileId() {
      var _this$changelog$clien;
      return ((_this$changelog$clien = this.changelog.clientProfileDetails) == null ? void 0 : _this$changelog$clien.id) || "";
    },
    clientProfileLink() {
      const {
        clientProfileId,
        boardId
      } = this;
      return {
        name: "client-profile",
        params: {
          clientProfileId,
          boardId
        }
      };
    }
  }
});